import { useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../../../hooks/useAxios";
import axiosInstance from "../../../apis/commonAPI";
// import {SESSION_DATA, user,} from "../../constants";
// import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CiSquarePlus } from "react-icons/ci";
import { FaMinus, FaPlus } from "react-icons/fa";


const AddEditStateDistrict = () => {
  const navigate = useNavigate();
const [districtArray, setDistrictArray] = useState([{'districtName':''}]);
const [addUpdate, setAddUpdate] = useState(false)
const { id } = useParams();
 


  const [submitForm, errorSubmit, loadingSubmit, axiosSubmit] =
    useAxios();
  const [stateData, errorState, loadingState, axiosState] =
    useAxios();


  const SUBMIT_FORM_URL = id && id != undefined?`master/updateStateDistrictData/${id}`:'master/createStateDistrictData';
  const GET_STATE_URL = id && id != undefined?`master/getStateDistrictData/${id}`:"";

  const getStateDistrict = (url) => {
    axiosState({
        axiosInstance: axiosInstance,
        url: url,
        method: "GET",
      });
    };
   


    useEffect(() => {
      const fetchStateData = async () => {
        if (!id) return;
    
        try {
           getStateDistrict(GET_STATE_URL);
        
        } catch (error) {
          console.error("Error fetching state data:", error);
        }
      };
    
      fetchStateData();
    }, [GET_STATE_URL]);

    useEffect(() => {
      const fetchStateDataB = async () => {
        if (!id) return;
    
        try {
          if (stateData?.length > 0) {
            setDistrictArray(stateData[0].districts);
            setValue("stateName", stateData[0].stateName);
          } else {
            console.warn("No state data found for the given ID");
          }
        } catch (error) {
          console.error("Error fetching state data:", error);
        }
      };
    
      fetchStateDataB();
    }, [loadingState]);
    

    
    console.log("state data", stateData)

  const form = useForm({
    defaultValues: {
    },
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField,
    reset,
  } = form;
  const { errors } = formState;

  const toTitleCase = (str) => {
    return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
      return match.toUpperCase();
    });
  };

  const onFormSubmit = async (data) => {
    
    if(districtArray.length>0){
      let formData = {
        stateName: toTitleCase(data.stateName),
        districts: districtArray,
        status: "A",
       
      };
  console.log("formData test",formData);
      await axiosSubmit({
        axiosInstance: axiosInstance,
        url: SUBMIT_FORM_URL,
        method: "POST",
        requestConfig: {
          data: formData,
        },
      });
  
      setAddUpdate(true);

    }else{
      
        toast.error(
          `Atleast One District is Required`,
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      
    }
    
  };
console.log("errorSubmit",errorSubmit)
  useEffect(() => {
    if (errorSubmit) {
      console.log("errorSubmit2",errorSubmit)

      toast.error(
        `Your information could not be Added!!error:${errorSubmit}`,
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    } else if (addUpdate) {
      navigate(
        `/master/stateDistrictlisting`
      );
    }
  }, [loadingSubmit, errorSubmit]);

  const handleDistrict = (isMinus, index = 0) => {
    if (isMinus) {
      const copyDistrict = [...districtArray];
      copyDistrict.splice(index, 1);
      setDistrictArray(copyDistrict);
      resetField(`districtName_${index}`)


     
    };
     if (isMinus === false) {
      const districtArrayCopy = [...districtArray];
      districtArrayCopy.push({ districtName: "" });
      setDistrictArray(districtArrayCopy);

    }
  }
  
  const handleDistrictValue = (e, index) => {
    const disValue = e.target.value;
    const updatedArray = [...districtArray];
  
    // Replace object with a new one
    updatedArray[index] = { ...updatedArray[index], districtName: toTitleCase(disValue) };
  
    setDistrictArray(updatedArray);
  };
  

  
  console.log("testt distric array",districtArray)
  return (
    <>
      <div className="card min-height-100">
        <div className="card-title flex-row">
          <h2>{id ? "Edit" : "Add"} State-District </h2>
          <Link to="/master/stateDistrictListing">
            <button type="button" className="btn btn-blue rounded-10">Back</button>
          </Link>
        </div>
        <ToastContainer />

        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30">
            <div className="col-md-4  tank-col-info">
                <label htmlFor="stateName" className="text-gray text-semi-bold">
                  State Name<span className="text-red">*</span>
                </label>
                <input
                  id="stateName"
                  {...register("stateName", {
                    required: {
                      value: true,
                      message: "State Name Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter State name"
                />
                <p className="text-red">{errors.stateName?.message}</p>
              </div>
              {
                districtArray?.map((fetchRows,index) => (
                  <div className="col-md-4  tank-col-info">
                    <div className= "row">

                    <div className="col-md-10">
                    <label htmlFor={`districtName_${index}`} className="text-gray text-semi-bold">
                    District<span className="text-red">*</span>
                  </label>
                  <input
                    id={`districtName_${index}`}
                    {...register(`districtName_${index}`, {
                      required: {
                        // value: true,
                        message: "district Name Field is Required",
                      },
                    })}
                    type="text"
                    className="form-control rounded-10 mb-15"
                    placeholder="Enter District"
                    onChange={(e) => handleDistrictValue(e, index)}
                    value={fetchRows.districtName}
                  />
                  <p className="text-red">{errors?.[`districtName_${index}`]?.message}</p>
</div>               
 
<span className="col-md-2 text-left mt-20">
<button
type="button"
                  className="btn btn-sm btn-outline-gray rounded-10"
                  title= "click to add district"
                  onClick={() => {handleDistrict(true,index)
                  }}
                
                ><FaMinus /></button>


</span>
                    </div>
                   

                

                </div>

                ))
              }
          
              <div className="col-md-4 text-left mt-20">
                <button
                type="button"

                  className="btn btn-sm btn-secondary rounded-10"
                  title= "click to add district"
                  onClick={() => {handleDistrict(false)
                  }}
                
                ><FaPlus /></button>
              </div>
            
            

              <div className="col-md-12 text-center">
                <input
                  type="submit"
                  className="btn btn-red rounded-10"
                  value="Submit"
                />
              </div>
            </div>
          </form>
        </FormProvider>

       
      </div>
    </>
  );
};

export default AddEditStateDistrict;
